import { useEffect, useRef, useState } from "react";
import { useT } from "../../../../i18n";
import "./TrendPanel.css";

// 진단 항목 드롭다운. 실계정(TrendPanel)과 데모(DemoData)가 같은 UI를 쓰도록 분리했다.
// 스타일은 TrendPanel.css 의 .calm-select-* 규칙을 따른다(미션 탭에서도 쓰므로 여기서 직접 불러온다).
// placeholder: 고른 값이 목록에 없을 때 버튼에 보일 문구. 안 주면 "항목 선택"(data.select.placeholder).
// disabled: 열리지 않게 잠근다.
function CalmSelect({ ariaLabel, value, options, onChange, placeholder, disabled = false }) {
  const t = useT();
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const selectedOption = options.find((option) => option.value === value);
  const fallbackLabel = placeholder ?? t("data.select.placeholder");

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnOutsideClick = (event) => {
      if (!rootRef.current?.contains(event.target)) setIsOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isOpen]);

  return (
    <div ref={rootRef} className={`calm-select${isOpen ? " is-open" : ""}${disabled ? " is-disabled" : ""}`}>
      <button
        type="button"
        className="calm-select-trigger"
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        disabled={disabled}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{selectedOption?.label || fallbackLabel}</span>
        <span className="calm-select-chevron" aria-hidden="true" />
      </button>

      {isOpen && !disabled && (
        <div className="calm-select-menu" role="listbox" aria-label={ariaLabel}>
          {options.map((option) => {
            const isSelected = option.value === value;
            return (
              <button
                key={option.value}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`calm-select-option${isSelected ? " is-selected" : ""}`}
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
              >
                <span>{option.label}</span>
                {isSelected && <span className="calm-select-check">✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CalmSelect;
